import React from 'react';

export default function EmptyState({ icon, title, hint }) {
  return (
    <div className="text-center py-14 px-8 pl-12">
      <div className="text-4xl mb-3">{icon}</div>
      <div className="font-playfair text-lg text-ink-mid mb-1">{title}</div>
      <div className="font-lora text-base text-ink-light italic">{hint}</div>
    </div>
  );
}